import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import FieldName from "src/components/Feedback/components/FieldName";
import FieldPhone from "src/components/Feedback/components/FieldPhone";
import FieldEmail from "src/components/Feedback/components/FieldEmail";
import { colors } from "src/config/colors";
import SubmitButton from "src/components/common/Buttons/SubmitButton";
import { SubmitHandler, useForm } from "react-hook-form";
import SelectTopic from "src/components/Feedback/components/SelectTopic";
import FieldComment from "src/components/Feedback/components/FieldComment";
import { toastAlert } from "src/components/common/SnackbarAlert/toastAlert";

export type FeedbackInputs = {
  name: string;
  phone: string;
  email: string;
  selectTopic: string;
  comment: string;
};

const FeedbackForm: React.FC = () => {
  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isValid },
  } = useForm<FeedbackInputs>({ mode: "onChange" });

  const onSubmit: SubmitHandler<FeedbackInputs> = (data) => {
    // Отправление отзыва
    toastAlert("Отправлено", "success");
  };

  return (
    <Stack
      onSubmit={handleSubmit(onSubmit)}
      noValidate
      component="form"
      spacing={1}
    >
      <Box display="flex" flexDirection="column" width="100%">
        <Typography component="h4" fontSize={16} color={colors.darkBlue}>
          Представьтесь
          <Typography component="span" color={colors.red}>
            {" "}
            *
          </Typography>
        </Typography>
        <FieldName errors={errors} register={register} />
      </Box>
      <Box display="flex" flexDirection="column" width="100%">
        <Typography component="h4" fontSize={16} color={colors.darkBlue}>
          Телефон
          <Typography component="span" color={colors.red}>
            {" "}
            *
          </Typography>
        </Typography>
        <FieldPhone control={control} errors={errors} />
      </Box>
      <Box display="flex" flexDirection="column" width="100%">
        <Typography component="h4" fontSize={16} color={colors.darkBlue}>
          Email
          <Typography component="span" color={colors.red}>
            {" "}
            *
          </Typography>
        </Typography>
        <FieldEmail errors={errors} register={register} />
      </Box>
      <Box display="flex" flexDirection="column" width="100%">
        <Typography
          component="h4"
          fontSize={16}
          color={colors.darkBlue}
          marginBottom={1}
        >
          Тема
          <Typography component="span" color={colors.red}>
            {" "}
            *
          </Typography>
        </Typography>
        <SelectTopic register={register} />
      </Box>
      <FieldComment register={register} />
      <SubmitButton
        type="submit"
        title="Отправить"
        height={45}
        disabled={
          !!errors.name ||
          !!errors.email ||
          !!errors.phone ||
          !!errors.selectTopic ||
          !isValid
        }
      />
    </Stack>
  );
};

export default FeedbackForm;
